import React from "react";
import { Add as AddIcon } from "@mui/icons-material";

import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { MRT_GlobalFilterTextField as GlobalFilterTextField } from "material-react-table";
import { APPROVAL_STATUS_OPTIONS } from "static/constants";

const TaskTableToolbar = ({
  table,
  handleAddTask,
  selectedTab,
  approvalStatus,
  onApprovalStatusChange,
}) => {
  const isArchivedOrAuditedTab = [
    "archived",
    "audited",
    "audited-archived",
  ].includes(selectedTab);

  const isPendingApprovalsTab = ["pending-approvals"].includes(selectedTab);

  return (
    <>
      <div className="table-toolbar">
        <div className="d-flex justify-between ">
          <div className="d-flex align-items-center" style={{ gap: 15 }}>
            {!isArchivedOrAuditedTab && <GlobalFilterTextField table={table} />}
            {isPendingApprovalsTab && (
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel shrink>Status</InputLabel>
                <Select
                  value={approvalStatus}
                  onChange={(e) => onApprovalStatusChange(e.target.value)}
                  label="Status"
                  displayEmpty
                  notched
                >
                  {APPROVAL_STATUS_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {!isArchivedOrAuditedTab && !isPendingApprovalsTab && (
              <Button
                onClick={handleAddTask}
                variant="contained"
                color="secondary"
                startIcon={<AddIcon />}
              >
                Add Task
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskTableToolbar;
